/* RESPONSIBLE TEAM: team-standalone */

import type { RequestAccessData } from '../definitions';
import type ZendeskPlatform from '../../zendesk';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';

export default class ZendeskRequestAccessData implements RequestAccessData {
  private platform: ZendeskPlatform;

  constructor(platform: ZendeskPlatform) {
    this.platform = platform;
  }

  get platformUrl() {
    if (this.platform.zendeskConfig?.subdomain) {
      return `https://${this.platform.zendeskConfig?.subdomain}.zendesk.com/agent/home`;
    }
    return undefined;
  }

  get platformName() {
    return this.platform.platformKey;
  }

  get imageUrl() {
    return assetUrl('/assets/images/standalone/copilot-on-zendesk.png');
  }
}
